document.addEventListener('DOMContentLoaded', () => {
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  const aboutSection = document.querySelector('.s-about-hero');
  if (!aboutSection) return;

  const images = aboutSection.querySelectorAll('.s-about-hero__image');
  const decors = aboutSection.querySelectorAll('.s-about-hero__decor');
  const titleDesktop = aboutSection.querySelector('.s-about-hero__title--desktop');
  const titleMobile = aboutSection.querySelector('.s-about-hero__title--mobile');
  const descDesktop = aboutSection.querySelector('.s-about-hero__description--desktop');
  const descMobile = aboutSection.querySelector('.s-about-hero__description--mobile');

  if (images.length) {
    gsap.fromTo(
      images,
      { opacity: 0, scale: 0.92 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.7,
        stagger: 0.12,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  if (decors.length) {
    gsap.fromTo(
      decors,
      { opacity: 0, scale: 0.85, rotate: -8 },
      {
        opacity: 1,
        scale: 1,
        rotate: 0,
        duration: 0.55,
        stagger: 0.1,
        ease: 'back.out(1.7)',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 80%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  if (titleDesktop) {
    gsap.fromTo(
      titleDesktop,
      { y: 24, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.65,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 78%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  if (titleMobile) {
    gsap.fromTo(
      titleMobile,
      { y: 24, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.65,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 78%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  if (descDesktop) {
    gsap.fromTo(
      descDesktop,
      { y: 18, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        delay: 0.15,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 78%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  if (descMobile) {
    gsap.fromTo(
      descMobile,
      { y: 18, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        delay: 0.15,
        duration: 0.6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: aboutSection,
          start: 'top 78%',
          toggleActions: 'play reverse play reverse',
        },
      }
    );
  }

  ScrollTrigger.refresh();
});
